var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9884\\u7EA6\\u8BA2\\u5355",
    transform: "translate(-67.492 1.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_2326",
    "data-name": "\\u8DEF\\u5F84 2326",
    d: "M82.742,46.546a2.423,2.423,0,0,1,2.423,2.423v8.077A6.461,6.461,0,0,1,78.7,63.507H72.242a2.423,2.423,0,0,1-2.423-2.423V48.969a2.423,2.423,0,0,1,2.423-2.423h10.5Zm0,1.212h-10.5a1.212,1.212,0,0,0-1.206,1.1l-.006.116V61.084a1.212,1.212,0,0,0,1.1,1.206l.116.006H78.7a5.25,5.25,0,0,0,5.247-5.062l0-.188V48.969a1.212,1.212,0,0,0-1.1-1.206Z",
    transform: "translate(0 -45.738)",
    fill: "#c59d60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_2327",
    "data-name": "\\u8DEF\\u5F84 2327",
    d: "M263.269,0a1.615,1.615,0,1,1,0,3.231h-5.654a1.615,1.615,0,1,1,0-3.231Z",
    transform: "translate(-182.95)",
    fill: "#c59d60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_2328",
    "data-name": "\\u8DEF\\u5F84 2328",
    d: "M331.832,69.818h-5.654a.4.4,0,0,0-.073.8l.073.006h5.654a.4.4,0,0,0,.073-.8Z",
    transform: "translate(-251.513 -68.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_2329",
    "data-name": "\\u8DEF\\u5F84 2329",
    d: "M230.157,393.775a.606.606,0,0,1,.082,1.206l-.082.006h-8.451a.606.606,0,0,1-.082-1.206l.082-.006Zm-3.6,3.465a.606.606,0,0,1,.082,1.206l-.082.006h-4.846a.606.606,0,0,1-.082-1.206l.082-.006Z",
    transform: "translate(-148.656 -386.942)",
    fill: "#c59d60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderActive);
export default __webpack_public_path__ + "static/media/orderActive.3c9b892a15c43ca15847154fb4891f59.svg";
export { ForwardRef as ReactComponent };